<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>薪资结构</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row style="text-align:left">
        <el-col :span="24">
          <el-form
           
            :inline="true"
            class="demo-form-inline"
            size="small"
          >
            <el-form-item>
              <el-select
                filterable
                v-model="TypeId"
                clearable
                placeholder="请选择岗位类别"
                size="small"
              >
                <el-option
                  v-for="(item, index) in JobSystemList"
                  :key="index"
                  :label="item.ClassName"
                  :value="item.Id"
                ></el-option>
              </el-select>
            </el-form-item>
            
           

            <el-form-item>
              <el-button size="small" icon="el-icon-search" @click="quotaSearch"
                >搜索</el-button
              >
            </el-form-item>
            <el-form-item style="float:right">
              <el-button type="primary" size="small" @click="quotaAdd"
                >添加固效比</el-button
              >
            </el-form-item>
            <el-form-item style="float:right">
              <el-button
                size="small"
                type="danger"
                @click="batchDeleteFixedPerformance()"
                >删除</el-button
              >
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table :data="tableData" ref="multipleTable" style="width: 100%">
            <el-table-column type="selection" width="50"></el-table-column>
             
            <el-table-column
              label="岗位类别"
              :show-overflow-tooltip="true"
              min-width="10%"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.PostTypes }}</span>
              </template>
            </el-table-column>

            <el-table-column
              label="固定比率"
              :show-overflow-tooltip="true"
              min-width="15%"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.Fixed.toFixed(2) }}</span>
              </template>
            </el-table-column>

            <el-table-column
              label="绩效比率"
              :show-overflow-tooltip="true"
              min-width="15%"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.Performance.toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="季度绩效比"
              :show-overflow-tooltip="true"
              min-width="15%"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.QuarterlyPerformance.toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="年度绩效比"
              :show-overflow-tooltip="true"
              min-width="15%"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.YearPerformance.toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="15%">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="handleEdit(scope.$index, scope.row)"
                  >编辑</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-row style="margin-top:10px">
            <el-col :span="24">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageIndex"
                :page-sizes="pageSizes"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
                style="float:right"
              ></el-pagination>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-card>
    <!-- <el-dialog title="编辑固效比信息" :visible.sync="dialogFormVisible"> -->
      
 <el-dialog :title="titleValue" :visible.sync="dialogFormVisible">
      <el-form
        :model="fixedForm"
       
        ref="fixedForm"
        :inline="true"
        class="demo-ruleForm"
        size="small"
      >
        <el-row >
          <el-col :span="24" >
            <el-form-item  label-width="150px" size="small" label="岗位类别" prop="SalaryMoney">
              <el-select
                filterable
                v-model="fixedForm.TypeId"
                clearable
                placeholder="岗位类别"
                
                size="small"
                prop="TypeId"
              >
                <el-option
                  v-for="(item, index) in JobSystemList"
                  :key="index"
                  :label="item.ClassName"
                  :value="item.Id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item  label-width="150px" size="small" label="固定比率" prop="Fixed">
              <el-input v-model="fixedForm.Fixed"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
         <el-row>
          <el-col :span="24">
            <el-form-item  label-width="150px" size="small" label="绩效比率" prop="Performance">
              <el-input v-model="fixedForm.Performance"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
           <el-row>
          <el-col :span="24">
            <el-form-item  label-width="150px" size="small" label="季度绩效比率" prop="QuarterlyPerformance">
              <el-input v-model="fixedForm.QuarterlyPerformance"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
         <el-row>
          <el-col :span="24">
            <el-form-item  label-width="150px" size="small" label="年度绩效比率" prop="YearPerformance">
              <el-input v-model="fixedForm.YearPerformance"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancelDialog">取 消</el-button>
        <el-button type="primary" @click="handleChangeDialog">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { Decrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic";
import {
 
  DeleteSysitem,
  GetSingleSysItem,
  GetSingleSysItemSort,
  AddSysItem,
  GetSysItemListByParentID,
  AddSalaryInfo,
  GetSingleSalaryInfo,
  DeleteSalaryInfo,
  GetFixedPerformanceList,
  GetSingleFixedPerformance,
  AddFixedPerformance,
  DeleteFixedPerformance
} from "../../until/ZeusApiSDK/Logic/SalaryStanded";
export default {
  data() {
    return {
      titleValue:"",
      JobSystemList: [], //岗位类别集合
    
      searchName: "", //搜索信息
      currentUser: {}, //当前用户
      tableData: [],
      pageSizes: [10, 20, 30, 50, 100],
      pageIndex: 1,
      pageSize: 10,
      totalCount: 0,
      TypeId:'',
      loading: true,
      visible: false,
      // 弹窗dialog
      dialogFormVisible: false,   
      fixedForm:{
        id:"",
        TypeId: "", //岗位类别ID
        PostTypes: "", //岗位类别
        Fixed: "", //固定比率
        Performance: "", //绩效比率
        QuarterlyPerformance: "",//季度绩效比率
        YearPerformance:"",// 年度绩效比率
        userCode:"",//工号
      },
      //表单规则验证
      // rules: {
      //   SalaryMoney: [
      //     { required: true, message: "请填写薪资标准", trigger: "blur" }
      //   ],
      //   TypeId: [
      //     { required: true, message: "请选择薪酬体系", trigger: "change" }
      //   ],
      //   RankID: [{ required: true, message: "请选择薪级", trigger: "change" }],
      //   LevelID: [{ required: true, message: "请选择薪档", trigger: "change" }]
      // }
    }
  },
  created() {
    //获取当前用户信息
    this.getCurrentUser();
    this.GetFixedPerformanceList();
    this.getJobSysitemList();
   
  },
  methods: {
   
    
    //获取岗位集合下拉列表
    getJobSysitemList: async function() {
      await GetSysItemListByParentID("7").then(res => {
        this.JobSystemList = res.Data.DataList;
        console.log(this.JobSystemList);
      });
    },

    //获取当前用户
    getCurrentUser: function() {
      var userinfo = window.sessionStorage.getItem("userinfo");
      userinfo = JSON.parse(Decrypt(userinfo));
      this.currentUser = userinfo;
    },
    //获取薪资结构列表
    GetFixedPerformanceList: async function() {
      this.loading = true;
      await GetFixedPerformanceList(
        this.pageIndex,
        this.pageSize,
        this.TypeId
        
      ).then(res => {
        this.loading = false;
        console.log(res.Data.DataList);
        this.tableData = res.Data.DataList;
        this.totalCount = res.Data.totalCount;
      });
    },
    //批量删除操作
    batchDeleteFixedPerformance: function() {
      var userArray = this.$refs.multipleTable.selection;
      console.log(userArray);
      if (userArray <= 0) {
        this.$message({
          type: "error",
          message: "请选择操作项"
        });
        return false;
      }
      this.loading = true;
      var ids = "";
      userArray.forEach(item => {
        if (ids != "") {
          ids += item.Id + ",";
        } else {
          ids += item.Id;
        }
      });
      //删除操作
      DeleteFixedPerformance(this.currentUser.UserCode, ids).then(res => {
        if (res.Code == "1") {
          this.$message({
            showClose: true,
            message: "删除成功",
            type: "success"
          });
          this.GetFixedPerformanceList();
        } else if (res.Code == "500") {
          this.$message({
            showClose: true,
            message: res.Msg,
            type: "error"
          });
          this.GetFixedPerformanceList();
        } else {
          this.$message({
            showClose: true,
            message: "未知",
            type: "error"
          });
          this.GetFixedPerformanceList();
        }
      });
    },
    quotaSearch() {
      // 初始化page页面
      this.initPage();
      // 执行搜索api
      this.GetFixedPerformanceList();
    },
    quotaAdd() {
      this.titleValue="新增数据";
      this.getJobSysitemList();
     
       // 关闭弹窗
      this.cancelDialog();
      // 打开弹窗
      this.openDialog();
    },
    handleEdit(index, row) {
    this.titleValue="编辑固效比信息";
      GetSingleFixedPerformance(row.Id).then(res => {
        
        if (res.Code == "200") {
           this.fixedForm = {
           id:res.Data.Id,
           TypeId:res.Data.TypeId, //岗位类别ID
           PostTypes: res.Data.PostTypes, //岗位类别
           Fixed:res.Data.Fixed, //固定比率
           Performance: res.Data.Performance, //绩效比率
           QuarterlyPerformance: res.Data.QuarterlyPerformance,//季度绩效比率
           YearPerformance:res.Data.YearPerformance,// 年度绩效比率
           userCode:this.currentUser.UserCode,//工号
           };
        }
      }),
        // 打开弹窗
        this.openDialog();
      // 点击取消 -> 弹窗清空
    },
    handleSizeChange(e) {
      this.initPage();
      this.pageSize = e;
      this.GetFixedPerformanceList();
    },
    handleCurrentChange(e) {
      this.pageIndex = e;
      this.GetFixedPerformanceList();
    },
    handleCancelDialog() {
      // 关闭弹窗
      this.cancelDialog();
    },
    handleChangeDialog() {
     // 编辑或新增保存
      if (this.fixedForm.id == undefined) {
        this.fixedForm.id = "";
      }
      var data = {
        id: this.fixedForm.id,
        TypeId: this.fixedForm.TypeId,
       PostTypes: this.fixedForm.PostTypes,
       Performance: this.fixedForm.Performance,
       QuarterlyPerformance: this.fixedForm.QuarterlyPerformance,
       YearPerformance: this.fixedForm.YearPerformance,
       Fixed: this.fixedForm.Fixed,
        userCode: this.currentUser.UserCode
      };
      console.log(data);
      AddFixedPerformance(data).then(res => {
        if (res.Code == "200") {
          this.$message({
            showClose: true,
            message: "操作成功",
            type: "success"
          });
        }  else {
          this.$message({
            showClose: true,
            message: res.Msg,
            type: "error"
          });
        }
        console.log(res.Msg);
        // 关闭弹窗
        this.cancelDialog();
      });
    },
    openDialog() {
      // 打开弹窗
      this.dialogFormVisible = true;
    },
    cancelDialog() {
      this.dialogFormVisible = false;
      this.fixedForm={
        id:"",
        TypeId: "", //岗位类别ID
        PostTypes: "", //岗位类别
        Fixed: "", //固定比率
        Performance: "", //绩效比率
        QuarterlyPerformance: "",//季度绩效比率
        YearPerformance:"",// 年度绩效比率
        userCode:"",//工号
      }
    },
    initPage() {
      this.pageIndex = 1;
      this.pageSize = 10;
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.sub {
  font-size: 12px;
  color: #8f8d8d;
  text-align: left;
  /* margin-top: 10px; */
}
/deep/.contentP {
  margin-top: 5px;
  margin-bottom: 5px;
}
/deep/.mainArea {
  margin: 20px;
  height: 30%;
}
/deep/.bottomInput {
  display: inline;
}
/deep/.web__main-user img {
  margin-top: 18px;
}
</style>
